import React from 'react';
import GroupTourForm from '../admin/GroupTourForm';

const BACK_TO = '/partner/group-trips';
const SUCCESS_TO = '/partner/group-trips';

export default function PartnerGroupTourFormPage(props) {
  return (
    <GroupTourForm
      {...props}
      backTo={BACK_TO}
      successTo={SUCCESS_TO}
    />
  );
}
